import React from "react";
import styles from "./adPrice.scss";
import { displayPrice, parsePriceString } from "../../../../services";

const AdPrice = ({ price, priceTo, previousPrice, className, isMobile, rentPriceType, priceType }) => {
  if (!price || price === 0) {
    return null;
  }

  return (
    <React.Fragment>
      {previousPrice && !isMobile && (
        <span className={styles.prevPrice}>
          {parsePriceString(previousPrice)}
        </span>
      )}


      <span className={`${styles.price} ${className}`} data-test="adprice">
        {displayPrice(price, priceTo, {rentPriceType, priceType})}
      </span>

      {previousPrice && isMobile && (
        <span className={styles.prevPrice}>
          {parsePriceString(previousPrice)}
        </span>
      )}


    </React.Fragment>
  );
};

AdPrice.defaultProps = {
  className: ""
}

export default AdPrice;



// WEBPACK FOOTER //
// ./src/components/AdCard/AdSummary/AdPrice/AdPrice.tsx